// Field configs for the "New client" wizard's Identity/Contact/Address/Banking
// steps. Split out from the step components so ReviewStep can reuse the same
// label/key list for its summary cards without duplicating it.

export const getIdentityFields = (isNaturalClient) =>
  isNaturalClient
    ? [
        { key: "name", label: "First Name", placeholder: "Enter First Name", required: true },
        { key: "surname", label: "Last Name", placeholder: "Enter Last Name", required: true },
        { key: "profession", label: "Profession", placeholder: "Enter Profession" },
        {
          key: "social_security_number",
          label: "Social Security Number",
          placeholder: "Enter Social Security Number",
        },
        {
          key: "social_security_series",
          label: "Social Security Series",
          placeholder: "Enter Social Security Series",
        },
        { key: "passport", label: "Passport", placeholder: "Enter Passport" },
      ]
    : [
        {
          key: "legal_company_name",
          label: "Legal Company Name",
          placeholder: "Enter Legal Company Name",
          required: true,
          wide: true,
        },
        {
          key: "legal_fiscal_code",
          label: "Legal Fiscal Code",
          placeholder: "Enter Legal Fiscal Code",
          required: true,
        },
        {
          key: "legal_unique_registration_code",
          label: "Unique Registration Code",
          placeholder: "Enter Unique Registration Code",
          // Ticked by default — most companies use the same value for both,
          // so the field mirrors legal_fiscal_code until unticked. The sync
          // itself lives in ClientModal.js; this just tells FieldsStep to
          // render the checkbox and disable manual editing while it's on.
          sameAsField: "legal_fiscal_code",
          sameAsToggleKey: "legal_urc_same_as_fiscal",
          sameAsLabel: "Same as fiscal code",
        },
        {
          key: "legal_trade_register_number",
          label: "Trade Register Number",
          placeholder: "Enter Trade Register Number",
          required: true,
        },
      ];

export const getContactFields = (isNaturalClient) => [
  {
    key: "personal_email",
    label: "Personal Email",
    placeholder: "Enter Email",
    type: "email",
    required: isNaturalClient,
  },
  ...(isNaturalClient
    ? []
    : [
        {
          key: "business_email",
          label: "Business Email",
          placeholder: "Enter Business Email",
          type: "email",
          required: true,
        },
      ]),
  {
    key: "mobile_phone_number",
    label: "Mobile Phone Number",
    placeholder: "Enter Mobile Phone Number",
    numericOnly: true,
    required: true,
  },
  {
    key: "land_phone_number",
    label: "Landline Phone Number",
    placeholder: "Enter Landline Phone Number",
    numericOnly: true,
  },
];

export const getAddressFields = (isNaturalClient) => [
  { key: "country", label: "Country", type: "country", required: true },
  { key: "region", label: "Region", placeholder: "Enter Region", required: true },
  { key: "city", label: "City", placeholder: "Enter City", required: true },
  ...(isNaturalClient
    ? [
        {
          key: "postal_code",
          label: "Postal Code",
          placeholder: "Enter Postal Code",
          numericOnly: true,
          required: false,
        },
      ]
    : []),
  { key: "address", label: "Address", placeholder: "Enter Address", required: true, wide: true },
];

export const getBankingFields = () => [
  { key: "iban_ron", label: "IBAN (RON)", placeholder: "Enter IBAN (RON)" },
  { key: "iban_euro", label: "IBAN (EUR)", placeholder: "Enter IBAN (EUR)" },
];

// Effective value for a "same as" field (see legal_unique_registration_code
// above): the mirrored field's value while its toggle is on, otherwise the
// field's own stored value. Computed on read everywhere it's needed —
// display, review, submit, validation — instead of synced into formik state
// via an effect, so there's nothing to keep in sync and no risk of it
// going stale mid-render.
export const getEffectiveValue = (field, values) => {
  if (field.sameAsField && field.sameAsToggleKey && values[field.sameAsToggleKey]) {
    return values[field.sameAsField];
  }
  return values[field.key];
};
